export const parseBoolean = (x: unknown): x is boolean => {
  return x === true || x === 'true'
}
